import axios from 'axios';
import { push } from 'react-router-redux';
// import ReactGA from 'react-ga';
import difference from 'lodash/difference';
import {filterXSS} from "xss";
import * as ActionCreators from './actionCreators';
import { ADD_USER_NAME, ADD_USER_COMMENT } from "../constants";

function uniqueId() {
  // Creates large random number and removes decimals
  return (Math.random() * 1e10) | 0; // eslint-disable-line
}

function createFileName(key, extension) {
  return `${key}-${uniqueId()}-${Date.now().toString()}.${extension}`;
}

function getFileSizeMB(el) {
  let fileSize = 0;
  if (el && el.files && el.files[0] && el.files[0].size) {
    fileSize = el.files[0].size; // bytes.
    return Math.round(fileSize / 1048576 * 100) / 100; // MB conversion.
  }
  return fileSize;
}

function validateConfig(config) {
  return dispatch => {
    const expectedKeys = ['signature', 'bucket', 'policy', 'key', 'acl'];
    const missingConfig = difference(expectedKeys, Object.keys(config));

    if (missingConfig.length > 0) {
      dispatch(ActionCreators.throwError('upload-error-general'));
      throw new Error(`S3.${missingConfig[0]} required`);
    } else {
      return () => {};
    }
  };
}

function queryParam(name) {
  const regex = RegExp(`[?&]${name}=([^&#]*)`)
  const parameter = window.location.search.match(regex)
  return parameter && parameter[1]
}

export function getUserInfo(accountInfo, locale) {
  return (dispatch, getState) => {
    const encodedEmailIndex = accountInfo.indexOf('_');
    const queryParametersIndex = accountInfo.indexOf('?');

    if (
      encodedEmailIndex !== -1 &&
      (queryParametersIndex > encodedEmailIndex || queryParametersIndex === -1)
    ) {
      const finalIndex =
        queryParametersIndex !== -1 ? queryParametersIndex : accountInfo.length;
      const decodedEmailInfo = window.atob(
        accountInfo.substring(encodedEmailIndex + 1, finalIndex),
      );
      const email = decodedEmailInfo.substr(decodedEmailInfo.indexOf('=') + 1);

      dispatch(ActionCreators.addUserEmail(email));
    }

    const headers = Object.assign(
        {
          Accept: 'application/json',
          Authorization: `Bearer ${getState().accessToken}`,
        },
        locale ? {'Accept-Language': locale} : null);
    axios
      .get(`${getState().basePath}/api/comments/${accountInfo}`, {
        headers
      })
      .then(response => {
        console.log('RESPONSE DATA:');
        console.log(response.data);
        dispatch(ActionCreators.updateCommentUserInfo(response.data));
        dispatch(ActionCreators.toggleCommentsInfoReceived(true));

        // Check for comment or name values in response object and send to Redux state if present
        const commentInput =
          response.data.comment && response.data.comment.input
            ? response.data.comment.input
            : undefined;

        if (
          commentInput &&
          commentInput.comment &&
          commentInput.comment.value
        ) {
          dispatch(
            ActionCreators.addTempUserComment(commentInput.comment.value),
          );
        }

        const utmSource = queryParam('utm_source');
        if (utmSource) {
          dispatch(ActionCreators.addTempCommentUtmSource(utmSource));
        }

        if (commentInput && commentInput.name && commentInput.name.value) {
          dispatch(ActionCreators.addTempUserName(commentInput.name.value));
        }

        // Check for image values in response object and send to Redux state if present
        const image1 =
          commentInput && commentInput.image1 ? commentInput.image1 : undefined;
        const image2 =
          commentInput && commentInput.image2 ? commentInput.image2 : undefined;
        const image3 =
          commentInput && commentInput.image3 ? commentInput.image3 : undefined;

        if (
          commentInput &&
          ((image1 && image1.value) ||
            (image2 && image2.value) ||
            (image3 && image3.value))
        ) {
          const uploadedImageObject = {
            url: '',
            cropped: false,
          };

          if (image1 && image1.value) {
            dispatch(
              ActionCreators.addUploadedPhoto(
                Object.assign({}, uploadedImageObject, { url: image1.value }),
                0,
              ),
            );
          }

          if (image2 && image2.value) {
            dispatch(
              ActionCreators.addUploadedPhoto(
                Object.assign({}, uploadedImageObject, { url: image2.value }),
                1,
              ),
            );
          }

          if (image3 && image3.value) {
            dispatch(
              ActionCreators.addUploadedPhoto(
                Object.assign({}, uploadedImageObject, { url: image3.value }),
                2,
              ),
            );
          }
        }

        // // Google Analytics
        // if (response.data.user && response.data.user.stp) {
        //   const queryParams = window.location.search
        //     ? window.location.search
        //     : '';
        //   ReactGA.initialize(getState().gaAccount);
        //   ReactGA.set({ dimension1: response.data.user.stp });
        //
        //   if (response.data.href.indexOf('/leader/comments') !== -1) {
        //     ReactGA.pageview(`/leader/comment${queryParams}`);
        //   } else {
        //     ReactGA.pageview(`/comment${queryParams}`);
        //   }
        // }
      })
      .catch(() => {
        // TODO - What to do with user view when info is not retrieved
      });
  };
}

export function validateCommentForm() {
  return (dispatch, getState) => {
    const { tempComment } = getState();
    let maxLengthForComment = getState().comment.comment.input.comment.maxlength;
    if (getState().tempComment.doubleByteExists && getState().comment.href.indexOf('/leader/comments') === -1) {
        maxLengthForComment = 200;  // max length for peer comment with double byte characters
    }

    // prevent XSS issues by escaping the name and comment values:
    const escapedName = filterXSS(tempComment.name);
    const escapedComment = filterXSS(tempComment.comment);
    Object.assign(getState().tempComment, { name: escapedName, type: ADD_USER_NAME});
    Object.assign(getState().tempComment, { comment: escapedComment, type: ADD_USER_COMMENT});

    const charactersRemaining = maxLengthForComment - getState().tempComment.comment.length;
    const errors = [];

    let disallowedWord;

    if (tempComment.name === '') {
      errors.push('name-required');
    }

    if (tempComment.comment === '') {
      errors.push('comment-required');
    }

    if (charactersRemaining < 0) {
      errors.push('comment-length');
    }

    if (tempComment.emojiExists) {
      errors.push('emojis-not-allowed');
    }

    const {
      comment: { comment: { input: { comment: { bannedWords } } } },
    } = getState();

    const usedWords = tempComment.comment.toLowerCase().split(/\W+/g);

    Object.values(bannedWords).forEach(bannedWord => {
      if (usedWords.includes(bannedWord)) {
        errors.push('comment-banned-word');
        disallowedWord = bannedWord;
      }
    });

    const errorString = errors.reduce((prev, curr) => `${prev}(${curr})`, '');

    dispatch(ActionCreators.throwError(errorString));

    if (disallowedWord) {
      dispatch(ActionCreators.throwBannedWordError(disallowedWord));
    } else if (errorString.length === 0) {
      dispatch(ActionCreators.togglePreview(true));
    }
  };
}

function createForm(upload) {
  const form = new FormData();
  form.append('key', upload.name);
  form.append('AWSAccessKeyId', upload.key);
  form.append('acl', upload.acl);
  form.append('policy', upload.policy);
  form.append('signature', upload.signature);
  form.append('Content-Type', upload.type);
  form.append('Content-Length', upload.file.length || upload.file.size);
  form.append('success_action_redirect', '');
  form.append('file', upload.file);

  return form;
}

export function autoOrientImage(index) {
  return (dispatch, getState) => {
    dispatch(ActionCreators.toggleImageLoading(index)); // Start spinner
    const currentImage = getState().uploadedImages[index];
    const autoOrientImageUrl = `/api/validation/image/autoOrient?image=${
        currentImage.url
    }`
    axios
        .get(
            autoOrientImageUrl,
        )
        .then(response => {
          const uploadedImageObject = {
            url: response.data.image,
            cropped: currentImage.cropped,
          };
          dispatch(ActionCreators.addUploadedPhoto(uploadedImageObject, index));
        })
        .catch(() => {
          dispatch(ActionCreators.throwError('autoOrient-image'));
          dispatch(ActionCreators.toggleImageLoading(-1)); // Stop spinner
        });
  };
}

function validateImage(imageUrl, imageNumber, validateUrl) {
  const uploadedImageObject = {
    url: imageUrl,
    cropped: false,
  };

  return dispatch => {
    axios
      .get(validateUrl)
      .then(response => {
        dispatch(ActionCreators.toggleImageLoading(-1)); // Stop spinner
        if (response.data.valid) {
          dispatch(ActionCreators.throwError(''));
          dispatch(
            ActionCreators.addUploadedPhoto(uploadedImageObject, imageNumber),
          );
          dispatch(autoOrientImage(imageNumber));
        } else if (!response.data.valid && response.data.invalid.type) {
          dispatch(ActionCreators.throwError(response.data.invalid.type.code)); // Invalid image type
        } else if (!response.data.valid && response.data.invalid.size) {
          dispatch(ActionCreators.throwError(response.data.invalid.size.code)); // Too small
        } else {
          dispatch(ActionCreators.throwError('could-not-validate'));
        }
        dispatch(ActionCreators.toggleImageLoading(-1)); // Stop spinner
      })
      .catch(() => {
        dispatch(ActionCreators.throwError('could-not-validate'));
      });
  };
}

export function uploadImage(image, event) {
  const el = event.currentTarget;

  /*
  Prevents IE11 from firing event multiple times when
  el.value = null is called at end of this function
  */
  if (!el || !el.files || !el.files[0]) {
    return () => {};
  }

  return dispatch => {
    if (getFileSizeMB(el) > 15) {
      dispatch(ActionCreators.throwError('image-filesize-too-large'));

    }else if(!(el.files[0].type === 'image/jpeg' || el.files[0].type === 'image/jpg' || el.files[0].type === 'image/png')){
      dispatch(ActionCreators.throwError('invalid-image-format'));

    }else{
      dispatch(validateConfig(image.config));

      const imageNumber = el.id.slice(-1) * 1;
      const parts = el.value.split('.');
      const extension =
          parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
      const fileName = createFileName(image.config.prefix, extension);
      const bucketUrl = `https://${image.config.bucket}.s3.amazonaws.com`;
      const imageUrl = `${bucketUrl}/${fileName}`;
      const validateUrl = image.validate.href.replace(
          '{&image}',
          `&image=${imageUrl}`,
      );

      const upload = Object.assign({}, image.config, {
        bucketUrl,
        name: fileName,
        url: imageUrl,
        type: el.files[0].type || 'application/octet-stream',
        file: el.files[0],
      });

      const form = createForm(upload);

      dispatch(ActionCreators.toggleImageLoading(imageNumber)); // Start spinner

      axios
          .post(bucketUrl, form)
          .then(() => {
            dispatch(validateImage(upload.url, imageNumber, validateUrl));
          })
          .catch(() => {
            dispatch(ActionCreators.toggleImageLoading(-1));
            dispatch(ActionCreators.throwError('network-error'));
          });
      el.value = null;
    };
    }


}

export function rotatePhoto(index) {
  return (dispatch, getState) => {
    const currentImage = getState().uploadedImages[index];

    axios
      .get(
        `/api/validation/image/rotate?degrees=90&image=${
          currentImage.url
        }`,
      )
      .then(response => {
        const uploadedImageObject = {
          url: response.data.image,
          cropped: currentImage.cropped,
        };
        dispatch(ActionCreators.throwError(''));
        dispatch(ActionCreators.addUploadedPhoto(uploadedImageObject, index));
      })
      .catch(() => {
        dispatch(ActionCreators.throwError('rotate-image'));
      });
  };
}

export function submitVideo(event) {
  event.preventDefault();
  // eslint-disable-next-line consistent-return
  return (dispatch, getState) => {
    // eslint-disable-line
    const { videoUpload } = getState();
    const title = document.querySelector('input[name="title"]').value;
    const el = document.getElementById('upload');

    // Validate upload
    if (title.length === 0) {
      return dispatch(ActionCreators.throwError('required'));
    } else if (el.files.length === 0) {
      return dispatch(ActionCreators.throwError('no-video'));
    } else if (getFileSizeMB(el) > 120) {
      return dispatch(ActionCreators.throwError('filesize-exceeded'));
    }

    dispatch(validateConfig(videoUpload.input.upload.config));
    dispatch(ActionCreators.displaySpinner(true));

    const parts = el.value.split('.');
    const extension =
      parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
    const fileName = createFileName(
      videoUpload.input.upload.config.prefix,
      extension,
    );
    const bucketUrl = `https://${
      videoUpload.input.upload.config.bucket
    }.s3.amazonaws.com`;
    const videoUrl = `${bucketUrl}/${fileName}`;

    const upload = Object.assign({}, videoUpload.input.upload.config, {
      bucketUrl,
      name: fileName,
      url: videoUrl,
      type: el.files[0].type || 'application/octet-stream',
      file: el.files[0],
    });

    const form = createForm(upload);

    // Upload to Amazon S3
    axios
      .post(bucketUrl, form)
      .then(() => {
        // Post video to O.C. Tanner comment
        const videoPayload = {
          title,
          url: videoUrl,
        };
        axios
          .post(videoUpload.action, videoPayload, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${getState().accessToken}`,
            },
          })
          .then(() => {
            dispatch(ActionCreators.throwError(''));
            dispatch(ActionCreators.displaySpinner(false));
            dispatch(ActionCreators.videoUploadSuccessful(true));
          })
          .catch(() => {
            dispatch(ActionCreators.throwError('general-video'));
            dispatch(ActionCreators.displaySpinner(false));
          });
      })
      .catch(() => {
        dispatch(ActionCreators.throwError('general-video'));
        dispatch(ActionCreators.displaySpinner(false));
      });
  };
}

export function captureFileName(event) {
  return dispatch => {
    dispatch(
      ActionCreators.addVideoFileName(
        event.currentTarget.value.split(/(\\|\/)/g).pop(),
      ),
    );
  };
}

export function submitComment() {
  return (dispatch, getState) => {
    dispatch(ActionCreators.displaySpinner(true));
    const category = getState().comment.href.includes('leader')
      ? 'Leader'
      : 'Peer';
    const { uploadedImages } = getState();
    const imageObj = {};

    if (category === 'Peer' && uploadedImages[0]) {
      imageObj.image = uploadedImages[0].url;
    } else if (category === 'Leader') {
      for (let i = 0; i < uploadedImages.length; i += 1) {
        if (uploadedImages[i]) {
          imageObj[`image${i + 1}`] = uploadedImages[i].url;
        }
      }
    }

    const commentPayload = Object.assign({}, getState().tempComment, imageObj);

    if (getState().comment.user && getState().comment.user.stp) {
      // ReactGA.set({ dimension1: getState().comment.user.stp });
    }

    axios
      .post(getState().comment.comment.action, commentPayload, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${getState().accessToken}`,
        },
      })
      .then(response => {
        if (response.data && response.data.video) {
          dispatch(ActionCreators.addVideoUploadConfig(response.data.video));
        }
        dispatch(ActionCreators.displaySpinner(false));
        dispatch(ActionCreators.togglePreview(false));
        dispatch(ActionCreators.toggleCommentsInfoReceived(false));
        dispatch(push(`${getState().basePath}/thanks`));
        // ReactGA.event({ category, action: 'Comment' });
      })
      .catch(err => {
        dispatch(ActionCreators.displaySpinner(false));

        // ERROR - Comment Too Long
        if (
          err.response.data &&
          err.response.data.comment &&
          err.response.data.comment.input &&
          err.response.data.comment.input.comment &&
          err.response.data.comment.input.comment.error
        ) {
          dispatch(ActionCreators.throwError('too-long-comment'));
          const errorObject = {
            event: {
              type: 'User Comment Too Long',
              message: err.response.data.comment.input.comment.error,
              pageUrl: getState().routing.locationBeforeTransitions.pathname,
              postUrl: getState().comment.comment.action,
              commentLength: commentPayload.comment.length,
            },
          };
          const encodedError = encodeURI(JSON.stringify(errorObject, null, 2));
          axios.get(
            `https://vision.appreciatehub.com/ui/greatwork/errors/log/entry?error=${encodedError}`,
          );
        } else if (err.response.status === 409) {
          // ERROR - Conflict - 2 Leader comments have been submitted on the same recipient
          dispatch(ActionCreators.throwError('conflict-comment'));
        } else {
          // Handle other errors
          dispatch(ActionCreators.throwError('network-comment'));
        }
      });
  };
}

/*
Polyfill for IE9 support.
Once IE9 support is dropped, this method can be removed and
replaced with el.classList.add(className) where it is called.
*/
export function addClass(el, className) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    el.className += ` ${className}`; // eslint-disable-line
  }
}

/*
Polyfill for IE9 support.
Once IE9 support is dropped, this method can be removed and
replaced with el.classList.remove(className) where it is called.
*/
export function removeClass(el, className) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    /* eslint-disable */
    el.className = el.className.replace(
      /* eslint-enable */
      new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'),
      ' ',
    );
  }
}
